import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {
  createVenue,
  editVenue,
  getVenueDetail
} from "@/store/venue-detail/action";
import {defaultCenter} from "@/config/maps";

const initialState = {
  venue: {
    name: '',
    address: '',
    address_lat: defaultCenter.lat,
    pic_phone_number: '',
    tax_fee: null,
    address_long: defaultCenter.lng,
    hour_rule_setting: true,
    court_pictures: [],
    prices: [],
    courts: []
  } as Venue,
  show: false,
  currentPrice: null,
  currentPriceIndex: -1,
  loadingAction: true,
  error: ''
} as VenueDetailState

const slice = createSlice({
  name: 'venueDetailSlice',
  initialState,
  reducers: {
    showPriceModal : (state, { payload }: PayloadAction<ShowModalActionPayload>) => {
      if (payload.show) {
        document.getElementById('root').style.overflow = 'hidden'
      } else {
        document.getElementById('root').style.overflow = 'auto'
      }
      return {
        ...state,
        show: payload.show,
        currentPrice: payload.currentPrice,
        currentPriceIndex: payload.currentPriceIndex
      }
    },
    resetVenueDetail: () => ({ ...initialState })
  },
  extraReducers: (builder) => {
    // getVenueDetail
    builder.addCase(getVenueDetail.fulfilled, (state, action) => {
      const venueDetail = action.payload
      return {
        ...state,
        loadingAction: false,
        venue: venueDetail as Venue
      }
    })
    builder.addCase(getVenueDetail.pending, (state) => ({
        ...state,
        loadingAction: true
      }
    ))
    builder.addCase(getVenueDetail.rejected, () => ({
        ...initialState,
        loadingAction: false
      }
    ))
    
    // createVenue
    builder.addCase(createVenue.fulfilled, (state) => ({
      ...state,
      loadingAction: false
    }))
    builder.addCase(createVenue.rejected, (state) => ({
        ...state,
        loadingAction: false
      }
    ))
    builder.addCase(createVenue.pending, (state) => ({
        ...state,
        loadingAction: true
      }
    ))
  
    // editVenue
    builder.addCase(editVenue.fulfilled, (state) => ({
      ...state,
      loadingAction: false
    }))
    builder.addCase(editVenue.rejected, (state) => ({
        ...state,
        loadingAction: false
      }
    ))
    builder.addCase(editVenue.pending, (state) => ({
        ...state,
        loadingAction: true
      }
    ))
  }
})

export const venueDetailActions = slice.actions

export default slice
